<template lang="pug">
.progress
  .progress__controls.progress-controls
    .progress-controls__item(
      v-hint.top="$tc('hint')"
      @click="goToLink()"
    )
      ion-icon(
        :name="ICONS.help"
      )
  |
  .progress__bar.progress-bar
    .progress-bar__item.progress-bar-item(
      v-for="(item, index) in ITEMS"
      :key="index"
    )
      .progress-bar-item__index
        span {{ index + 1 }}
      |
      .progress-bar-item__label {{ item.label }}
</template>

<i18n src="./ProcessProgress.i18n.json"></i18n>

<script>
const ICONS = {
  help: "help-circle",
};

const URL_TO_GUIDE =
  "https://intercom.help/betternations/en/articles/6717976-step-by-step-process-to-sponsor-your-candidate";

const ITEMS = [
  {
    label: "Get a Sponsor Licence",
  },
  {
    label: "Check your candidate for visa eligibility",
  },
  {
    label: "Create CoS for a candidate",
  },
  {
    label: "Submit visa application",
  },
];

export default {
  name: "ProcessProgress",
  data: () => ({
    ICONS,
    ITEMS,
  }),
  methods: {
    goToLink() {
      window.open(URL_TO_GUIDE, "_blank");
    },
  },
};
</script>

<style lang="sass" scoped>
.progress
  display: flex
  justify-content: center
  align-items: center
  position: relative
  background-color: var(--white_color)
  padding: 2.5rem
  border: solid 1px var(--border_color)
  border-radius: 0.5rem
  margin-top: toRem(12px)

.progress-controls
  display: flex
  position: absolute
  top: 0.5rem
  right: 0.5rem
  column-gap: 0.5rem
  color: var(--primary_color)

  &__item
    font-size: 1.5rem
    cursor: pointer

.progress-bar
  display: flex
  flex-wrap: nowrap
  column-gap: 2em

$circle-size: 1.75rem

.progress-bar-item
  display: inline-flex
  display: -webkit-inline-flex
  display: -ms-inline-flexbox
  flex-direction: column
  row-gap: 0.75em
  align-items: center
  align-content: center
  font-weight: normal
  text-transform: none
  max-width: 15rem
  flex: 1 1
  position: relative

  &:last-child
    &:after
      display: none !important

  &:after
    content: ""
    height: 1px
    width: calc(100% + 5px)
    background-color: var(--dark-primary-5_color)
    position: absolute
    top: calc($circle-size / 2)
    left: calc(50% + ($circle-size / 2))

  &__index
    $circle-size: 1.75rem
    width: $circle-size
    min-width: $circle-size
    max-width: $circle-size
    height: $circle-size
    min-height: $circle-size
    max-height: $circle-size
    display: inline-flex
    justify-content: center
    align-items: center
    border: 1px solid var(--dark-primary-5_color)
    border-radius: 50%
    color: var(--dark-primary-5_color)

    span
      font-size: 0.75rem

  &__label
    text-align: center
    white-space: pre-line
    color: var(--dark-primary-7__color)
</style>
